import { useState, useEffect } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { X } from "lucide-react";
import { useParams } from "react-router-dom";

const Issues = () => {
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedArticle, setSelectedArticle] = useState(null);
    const { id,issue } = useParams();

    useEffect(() => {
        const fetchArticles = async () => {
            try {
                const response = await fetch(`https://backend.impactjournal.co.in/manuscript/allarticle/${id}/${issue}`);
                if (!response.ok) throw new Error("Failed to fetch articles");
                const data = await response.json();
                setArticles(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchArticles();
    }, []);

    // 🚫 Disable background scroll when modal is open
    useEffect(() => {
        if (selectedArticle) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        // cleanup in case component unmounts
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [selectedArticle]);

    return (
        <div className="search-page">
            <div className="search-page-main-impact">
                {/* Section Heading */}
                <h2 className="review-article-title">Latest Articles</h2>
                <hr className="review-article-divider" />

                {/* Main Results */}
                <div className="search-page-main-right">
                    {loading && <p>Loading articles...</p>}
                    {error && <p className="error">{error}</p>}

                    {!loading && !error && articles.length > 0 ? (
                        articles.map((article, index) => (
                            <div key={index} className="search-page-article-item">
                                <div className="search-page-main-category-name">
                                    <p>{article.articleCategory}</p>
                                </div>
                                <div className="search-page-main-article-name">
                                    <h2>{article.articleTitle}</h2>
                                </div>
                                <div className="search-page-main-time-impact">
                                    <p>
                                        Published On -{" "}
                                        {new Date(article.createdAt).toLocaleDateString()}
                                    </p>
                                </div>
                                <div className="search-page-main-author-name">
                                    <p>{article.name}</p>
                                </div>
                                {/* Read Article Button */}
                                <div className="read-article-btn-wrapper">
                                    <button
                                        className="issue-button"
                                        onClick={() =>
                                            setSelectedArticle(
                                                `https://backend.impactjournal.co.in/uploads/manuscripts/${article.file}`
                                            )
                                        }
                                    >
                                        Read Article
                                    </button>
                                </div>
                            </div>
                        ))
                    ) : (
                        !loading && <p>No results found.</p>
                    )}
                </div>
            </div>

            {/* Fullscreen Modal */}
            {selectedArticle && (
                <div className="issue-modal-overlay">
                    <div className="issue-modal-content">
                        <button
                            className="issue-close-modal-btn"
                            onClick={() => setSelectedArticle(null)}
                        >
                            <X />
                        </button>

                        {/* PDF Viewer (no download option) */}
                        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                            <Viewer fileUrl={selectedArticle} />
                        </Worker>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Issues;
